// Prevent disabled button clicks
$('a.disabled').on('click', function(e) {
  e.preventDefault();
});

// Client-size search validation
$('.search-form').on('submit', function (e) {
    var searchForm = $(this),
        searchInput = searchForm.find('.search-field'),
        searchString = searchInput.val(),
        searchError = searchForm.find('.search-error');

    if ( $.trim(searchString).length < 3 ) {
        e.preventDefault();
        searchError.fadeIn('fast');
        searchInput.addClass('has-error');
        searchInput.focus();
    } else {
        // Hide errors
        searchInput.removeClass('has-error');
        searchError.fadeOut('fast');
        searchForm.off('submit');
        // Track event
        StepStone.trackEvent('search', 'site_search', searchString.toLowerCase().trim().replace(/[\W_]+/g, '_') );
        searchForm.submit();
    }

    searchInput.on('keypress keyup', function () {
        if ( searchInput.val().length > 2 ) {
            searchInput.removeClass('has-error');
            searchError.fadeOut('fast');
        }
    });
});

// Modals
$('.js-show-modal').on('click', function(e){
  e.preventDefault();
  $('html, body').addClass('no-scroll');
  $('.modal-overlay').fadeIn(300);
});

$('.js-hide-modal').on('click', function(e){
  e.preventDefault();
  $('html, body').removeClass('no-scroll');
  $('.modal-overlay').fadeOut(300);
});

$('#stepstone-sub-menu-dropdown').on('change input', function () {
    var selectedOption = $(this).find(':selected');

    // If not already on page, navigate to selected page
    if ( ! selectedOption.hasClass('current-page') ) {
        $(this).parent('.stepstone-subsection-dropdown-menu').addClass('loading');
        $(this).prop('disabled', true).addClass('disabled');
        window.location.replace( selectedOption.data('url') );
    }
});